export default __webpack_public_path__ + "static/media/CheckedRadioImage.95d49a0d.svg";